// extracted by mini-css-extract-plugin
export default {"main":"DetailedInfo_main__siuSy","info":"DetailedInfo_info__hUHKw"};